import React from 'react';

import ParagraphImage from './Default';
import ParagraphImageGetStarted from './GetStarted';

const Video = (props) => {
  const { viewMode } = props;

  if (viewMode === 'getStarted') {
    return <ParagraphImageGetStarted {...props} />;
  }

  return <ParagraphImage {...props} />;
};

export default Video;
